import Shepherd from 'shepherd.js';

export const tour = new Shepherd.Tour({
	useModalOverlay: true,
	defaultStepOptions: {
		classes: 'shadow-md bg-purple-dark',
		scrollTo: false,
		modalOverlayOpeningPadding: 4,
		modalOverlayOpeningRadius: 4,
		arrow: true
	}
});

tour.addStep({
	id: 'step-1',
	title: 'Step 1',
	text: 'Begin creating your new grid by clicking "Start From Scratch" button.',
	attachTo: {
		element: '.tour-step-1',
		on: 'left'
	},
	when: {
		show: function () {
			document
				.querySelector('.tour-step-1')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	classes: 'example-step-1',
	cancelIcon: {
		enabled: true,
		label: 'Cancel tutorial'
	}
});

tour.addStep({
	id: 'step-2',
	title: 'Step 2',
	text: 'Please enter a name for your new grid and select the page type you intend to use your grid on. After you are ready click "Save" to create your new grid.',
	attachTo: {
		element: '#title',
		on: 'right'
	},
	classes: 'example-step-2',
	cancelIcon: {
		enabled: true
	}
});
tour.addStep({
	id: 'step-3',
	title: 'Step 3',
	text: 'Once your grid is created you can start customizing it by clicking the settings icon. Later use this icon to make additional changes to your already published grids.',
	beforeShowPromise: function () {
		return new Promise(function (resolve) {
			setTimeout(() => {
				resolve();
			}, 1000);
		});
	},
	when: {
		show: function () {
			document
				.querySelector('.example-step-3')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	classes: 'example-step-3',
	cancelIcon: {
		enabled: true
	}
});
tour.addStep({
	id: 'step-4',
	title: 'Step 4',
	text: 'In this panel you can edit and customize your grid.',
	beforeShowPromise: function () {
		return new Promise(function (resolve) {
			setTimeout(() => {
				resolve();
			}, 1000);
		});
	},
	classes: 'example-step-4',
	buttons: [
		{
			text: 'Next',
			action: tour.next
		}
	],
	cancelIcon: {
		enabled: true
	}
});

tour.addStep({
	id: 'step-5',
	title: 'Step 5',
	text: 'Click here to add elements to your grid.',
	when: {
		show: function () {
			document
				.querySelector('.tour-step-5')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	attachTo: {
		element: '.tour-step-5',
		on: 'bottom'
	},
	classes: 'example-step-5',
	cancelIcon: {
		enabled: true
	}
});
tour.addStep({
	id: 'step-6',
	title: 'Step 6',
	text: 'Fill out this form  and click "Create" to add your first grid element. <br> &#9432; : <i> <b>Dynamic Collections</b> are personalised recommendations that are created for users based on their online activity. If a user has no activity we show <b>Static Collections</b> which are based on overall website activity.</i>',
	attachTo: {
		element: '.dialog',
		on: 'right'
	},
	classes: 'example-step-6',
	cancelIcon: {
		enabled: true
	}
});

tour.addStep({
	id: 'step-7',
	title: 'Step 7',
	text: 'In this section you can control the general styles of your grid.',
	when: {
		show: function () {
			document
				.querySelector('.tour-step-7')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	attachTo: {
		element: '.tour-step-7',
		on: 'top'
	},
	classes: 'example-step-7',
	buttons: [
		{
			text: 'Next',
			action: tour.next
		}
	],
	cancelIcon: {
		enabled: true
	}
});
tour.addStep({
	id: 'step-8',
	title: 'Step 8',
	text: 'This section allows you to style the headings of your grid elements.',
	when: {
		show: function () {
			document
				.querySelector('.tour-step-8')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	attachTo: {
		element: '.tour-step-8',
		on: 'top'
	},
	classes: 'example-step-8',
	buttons: [
		{
			text: 'Next',
			action: tour.next
		}
	],
	cancelIcon: {
		enabled: true
	}
});
tour.addStep({
	id: 'step-9',
	title: 'Step 9',
	text: 'From this section you can control the general styles of the products shown in your grid.',
	when: {
		show: function () {
			document
				.querySelector('.tour-step-9')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	attachTo: {
		element: '.tour-step-9',
		on: 'top'
	},
	classes: 'example-step-9',
	buttons: [
		{
			text: 'Next',
			action: tour.next
		}
	],
	cancelIcon: {
		enabled: true
	}
});
tour.addStep({
	id: 'step-10',
	title: 'Step 10',
	text: 'From this section you can style how product prices and sale prices look in your grid.',
	when: {
		show: function () {
			document
				.querySelector('.tour-step-10')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	attachTo: {
		element: '.tour-step-10',
		on: 'top'
	},
	classes: 'example-step-10',
	buttons: [
		{
			text: 'Next',
			action: tour.next
		}
	],
	cancelIcon: {
		enabled: true
	}
});

tour.addStep({
	id: 'step-11',
	title: 'Step 11',
	text: 'When you are ready with customizing your grid you have the option to preview it before publishing.',
	attachTo: {
		element: '.tour-step-11',
		on: 'left'
	},
	when: {
		show: function () {
			document
				.querySelector('.tour-step-11')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	classes: 'example-step-11',
	cancelIcon: {
		enabled: true
	}
});

tour.addStep({
	id: 'step-12',
	title: 'Step 12',
	text: 'Once you are happy with how your grid looks save your settings by clicking "Save grid".',
	attachTo: {
		element: '.tour-step-12',
		on: 'left'
	},
	when: {
		show: function () {
			document
				.querySelector('.tour-step-12')
				.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	},
	classes: 'example-step-12',
	cancelIcon: {
		enabled: true
	}
});

tour.addStep({
	id: 'step-13',
	title: 'Step 13',
	text: 'Now that your new grid is saved click here to view the embed code needed to insert the grid in your website.',
	classes: 'example-step-13',
	cancelIcon: {
		enabled: true
	}
});

tour.addStep({
	id: 'step-14',
	title: 'Step 14',
	text: `Copy and paste the <b>Script code</b> in the &lt;head&gt; tag of your website. This step is done only <b>once per website</b>. <br>  <br> Copy and paste the <b>HTML code</b> wherever you want your grid to appear on your website. This step is done <b>once for every new grid you create</b>. <br> <br> For more information you can visit our <a href="https://docs.shopbox.ai/docs/shopbox-grid/implementation#prerequisites" target="_blank" id="tour-link">docs</a>.`,
	attachTo: {
		element: '.tour-step-14',
		on: 'right'
	},
	classes: 'example-step-14',
	buttons: [
		{
			text: 'Finish tour',
			action: tour.next
		}
	],
	cancelIcon: {
		enabled: true
	}
});
// tour.addStep({
// 	id: 'step-15',
// 	title: 'Step 15',
// 	text: 'Copy and paste the <b>HTML code</b> wherever you want your grid to appear on your website. This step is done only once for every new grid you create. For more information you can visit our <a href="https://docs.shopbox.ai/docs/shopbox-grid/implementation#prerequisites" target="_blank" id="tour-link">docs</a>.',
// 	attachTo: {
// 		element: '.tour-step-15',
// 		on: 'right'
// 	},
// 	classes: 'example-step-15',
// 	buttons: [
// 		{
// 			text: 'Finish tour',
// 			action: tour.next
// 		}
// 	],
// 	cancelIcon: {
// 		enabled: true
// 	}
// });
